import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

export const storeIdGuard: CanActivateChildFn = (_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  // state.url contains the path we are trying to go to
  const targetPath = state.url;
  const pathParams = targetPath.split('/');
  
  if (!pathParams.length && environment.allowTest) {
    return router.navigate(['test']);
  }

  if (targetPath?.includes('/404')) {
    return router.navigate(['404']);
  }
  // We need at least the `/{storeId}` path param to allow access to menu
  // Also the storeId must not equal "test" since this is the path for our test page
  return pathParams.length > 0 || router.navigate(['no-store-error']);
};
